import jquery from 'jquery';
import { ez_consent } from 'ez-consent';
import Rellax from 'rellax';

window.jQuery = jquery;
window.$ = jquery;

window.ez_consent = ez_consent;

var rellax = new Rellax('.rellax');